import React, { useState, useEffect } from "react";
import Body from "../../Common/Body";
import moment from "moment";
import ContentCard from "../../Common/Layout/ContentCard";
import useFetch from "../../../hooks/useFetch";
import ProductFilters from "./ProductFilters";
import { ProductTable } from "./ProductTable";

const Products = () => {
  moment.locale();
  const [maxPagination, setMaxPagination] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataFetched, setDataFetched] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    orderBy: "productName+asc",
    dateFrom: moment().startOf("month").format("YYYY-MM-DD"),
    dateUntil: moment().format("YYYY-MM-DD"),
  });

  const { get } = useFetch();

  useEffect(() => {
    setIsLoading(true);
    let url = `/reports/products?page=${currentPage}&`;
    Object.keys(filters).forEach((key) => {
      url += key + "=" + filters[key] + "&";
    });

    get(url)
      .then(async (res) => {
        setDataFetched(res);
        setMaxPagination(res.total);
      })
      .catch((e) => {
        console.log(e);
        throw new Error(e);
      })
      .finally(() => setIsLoading(false));
  }, [filters, currentPage]);

  const handleSelectedPage = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Body title={"Reporte de artículos"}>
        <ContentCard>
          <ProductFilters
            filters={filters}
            setFilters={setFilters}
          ></ProductFilters>
        </ContentCard>
        <ContentCard>
          <ProductTable
            filters={filters}
            setFilters={setFilters}
            isLoading={isLoading}
            maxPagination={maxPagination}
            currentPage={currentPage}
            products={dataFetched.products}
            handleSelectedPage={handleSelectedPage}
          ></ProductTable>
        </ContentCard>
      </Body>
    </>
  );
};

export default Products;
